// Observer für Klassänderungen am .header-background Element
const headerBackground = document.querySelector('.header-background');
const headerSticky = document.querySelector('.header-sticky');

if (headerBackground && headerSticky) {
    // Funktion zum Aktualisieren der min-height
    const updateMinHeight = () => {
        if (headerBackground.classList.contains('header-background-no-background')) {
            const stickyHeight = headerSticky.offsetHeight;
            headerBackground.style.minHeight = `${stickyHeight}px`;
        } else {
            headerBackground.style.minHeight = '';
        }
    };

    // MutationObserver für Klassänderungen am header-background
    const classObserver = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                updateMinHeight();
            }
        });
    });

    // ResizeObserver für Größenänderungen am header-sticky
    const resizeObserver = new ResizeObserver(() => {
        updateMinHeight();
    });

    // Observer starten
    classObserver.observe(headerBackground, {
        attributes: true,
        attributeFilter: ['class']
    });

    resizeObserver.observe(headerSticky);

    // Initiale Überprüfung
    updateMinHeight();
}
